export const CONSIGNMENT_NOTE = 'CONSIGNACIÓN — mercadería no cobrada';

export const PAYMENT_METHOD_LABELS = {
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  debito: 'Débito',
  credito: 'Crédito',
  consignacion: 'Consignación'
};

export function emptyPaymentMethods() {
  return {
    efectivo: false,
    transferencia: false,
    debito: false,
    credito: false,
    consignacion: false
  };
}

export function formatPaymentMethodLabel(key) {
  if (!key) return '';
  return PAYMENT_METHOD_LABELS[key] || (key.charAt(0).toUpperCase() + key.slice(1));
}

export function formatPaymentMethods(methodsObj, emptyLabel = 'No especificado') {
  const labels = Object.entries(methodsObj || {})
    .filter(([, value]) => !!value)
    .map(([key]) => formatPaymentMethodLabel(key));
  return labels.length ? labels.join(', ') : emptyLabel;
}

export function isConsignmentSale(sale) {
  if (!sale) return false;
  if (sale.isConsignment === true || sale.saleType === 'consignacion') return true;
  return !!(sale.paymentMethods && sale.paymentMethods.consignacion);
}

export function isUnpaidSale(sale) {
  if (!sale) return false;
  if (sale.isPaid === true) return false;
  if (isConsignmentSale(sale)) return true;
  return sale.isPaid === false;
}

export function withConsignmentNote(existing, isConsignment) {
  const extra = String(existing || '').trim();
  if (!isConsignment) return extra;
  if (!extra) return CONSIGNMENT_NOTE;
  if (extra.includes(CONSIGNMENT_NOTE) || extra.toLowerCase().includes('consignaci')) return extra;
  return `${CONSIGNMENT_NOTE}\n${extra}`;
}
